<div class="tt-guideline-update-message-dialog_description">
  @if (!data.options?.hideDescription) {
    {{ 'SmartbookMessageDialog.Description' | transloco: { userName: data.infoData.publisher } }}
    <span>{{ data.infoData.publisher | name }}</span>
    {{ 'SmartbookMessageDialog.Updated' | transloco }}
    @if (data.message) {
      <div>{{ 'SmartbookMessageDialog.SummaryOfChanges' | transloco }}:</div>
    }
  }
</div>
<div class="tt-guideline-update-message-dialog_container">
  @if (data.message) {
    <common-rich-text-view [content]="data.message" />
  } @else {
    <span class="tt-guideline-update-message-dialog_no-message">{{ 'SmartbookMessageDialog.NoMessage' | transloco }}</span>
  }
</div>
<div class="tt-guideline-update-message-dialog_footer">
  <div class="tt-guideline-update-message-dialog_footer-info">
    @if (data.infoData.version; as version) {
      <span>{{ 'Version' | transloco }}:&nbsp;</span>
      {{ data.infoData.version }}&nbsp;
    }
    {{ 'UpdatedAt' | transloco }}: {{ data.infoData.updatedAt }}&nbsp;
    @if (data.infoData.publisher?.firstName && data.infoData.publisher?.lastName) {
      {{ data.options?.publisherKey ?? 'SmartbookMessageDialog.ReleasedBy' | transloco }}: {{ data.infoData.publisher | name }}
    }
  </div>
  <button ttButton [variant]="'secondary'" (click)="onClose()">
    <span>{{ 'Close' | transloco }}</span>
  </button>
</div>
